// Import stylesheets
import "../stylesheets/application.scss";

// Import and start Turbo
import "@hotwired/turbo-rails";

// Import Trumbowyg plugins
import "trumbowyg/dist/plugins/colors/trumbowyg.colors.min";
import "trumbowyg/dist/plugins/noembed/trumbowyg.noembed.min";

// Import uuid
import { v1 as uuidv1 } from "uuid";

// Custom fields functionality
function randomId() {
  return uuidv1();
}

function newCustomFieldsRowHtml(randomId) {
  return (
    '<tr><td><input name="listing[custom_fields[' +
    randomId +
    '][title]]" type="text" value="" ></input></td>' +
    '<td><input name="listing[custom_fields[' +
    randomId +
    '][value]]" type="text" value="" ></input></td>' +
    '<td><button type="button" class="js-remove-custom-field-btn">Remove Field</button></td></tr>'
  );
}

$(document).on("click", "#add-new-custom-field-btn", function (event) {
  const rid = randomId();
  $("#custom-fields-table tr:last").after(newCustomFieldsRowHtml(rid));
});

$(document).on("click", ".js-remove-custom-field-btn", function (event) {
  $(event.target).parents("tr").remove();
});
